<template>
    <div>
        <edit-password
            v-model="value"
            name="password"
            @validation-change="isPasswordValidAndConfirmed = $event"
            @password-confirmation-update="handlePasswordConfirmationUpdate"
        />

        <div class="text-right">
            <button
                type="submit"
                class="btn btn-md is-primary"
                :disabled="! isPasswordValidAndConfirmed"
            >
                <span v-if="action === 'reset'">
                    {{ lang('Återställ lösenord', 'Reset password') }}
                </span>
                <span v-else>
                    {{ lang('Aktivera lösenord', 'Activate password') }}
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        action: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            value: '',
            isPasswordValidAndConfirmed: false,
            passwordConfirmation: '',
        };
    },

    methods: {
        handlePasswordConfirmationUpdate(passwordConfirmation) {
            this.passwordConfirmation = passwordConfirmation;
        },
    },
};
</script>
